import { judging } from "../data";
import SectionHeading from "./SectionHeading";

export default function JudgingSection() {
  return (
    <section id="judge" className="bg-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-1">
            <SectionHeading
              eyebrow="Scoring"
              title="评选标准"
              desc="评委从四个维度打分，大众投票另有权重。想拿高分，先搞懂分数是怎么来的。"
            />
            <div className="mt-6 p-5 rounded-lg bg-background-50 border border-background-200">
              <p className="text-xs font-label tracking-wide text-foreground-500">最终成绩公式</p>
              <p className="mt-2 font-heading text-lg md:text-xl font-black text-foreground-950 leading-snug">
                专业评委 × 70%
                <span className="mx-2 text-primary-500">+</span>
                大众投票 × 30%
              </p>
              <p className="mt-3 text-xs text-foreground-600 leading-relaxed">
                评委评分满分 100，四个维度按权重加权；大众投票按票数区间折算为百分制后计入。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {judging.map((item) => (
              <article
                key={item.name}
                className="p-5 rounded-lg bg-background-50 border border-background-200"
              >
                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 shrink-0 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-4">
                      <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {item.name}
                      </h3>
                      <span className="font-heading text-base md:text-lg font-black text-primary-600 shrink-0">
                        {item.weight}%
                      </span>
                    </div>
                    <div className="mt-2.5 w-full h-2 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${item.weight}%` }}
                      />
                    </div>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}